// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Grid,
  Typography
} from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PhoneIcon from '@mui/icons-material/Phone';

const Footer = () => {
  const { t, i18n } = useTranslation('common');
  const currentYear = new Date().getFullYear();

  // 跨產品連結(維修雲 / Roblox)只在中文介面顯示 — 兩者為中文-only 落地頁(見 Plan 105)。
  const isZh = (i18n.language || 'zh-TW').startsWith('zh');

  return (
    <Box
      component="footer"
      sx={{
        py: 6,
        backgroundColor: '#3664D1',
        color: 'white'
      }}
    >
      <Container>
        <Grid container spacing={4} alignItems="flex-start">
          {/* Logo and Contact Section */}
          <Grid item xs={12} md={4}>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
              <img
                src="https://agent-rebaz-ai.s3.ap-northeast-1.amazonaws.com/rebaz_logo_3.png"
                alt="Rebaz Logo"
                style={{
                  height: '40px',
                  marginRight: '8px',
                  filter: 'brightness(0) invert(1)'
                }}
              />
            </Box>
            <Typography variant="body2" sx={{ mb: 3 }}>
              Step Out of Routines
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
              <EmailIcon sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">
                service@rebaz.ai
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <PhoneIcon sx={{ mr: 1, fontSize: 20 }} />
              <Typography variant="body2">
                +8862-27081199
              </Typography>
            </Box>
          </Grid>

          {/* Product Column */}
          <Grid item xs={6} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {t('footer.product')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link to="/features" style={{ color: 'white', textDecoration: 'none' }}>
                {t('footer.features')}
              </Link>
              <Link to="/pricing" style={{ color: 'white', textDecoration: 'none' }}>
                {t('footer.pricing')}
              </Link>
              {/* 跨產品連結 — 中文-only 頁,只在中文介面顯示,絕對網址(header/footer 兩網域共用) */}
              {isZh && (
                <>
                  <a href="https://rebaz.ai/aiops/" style={{ color: 'white', textDecoration: 'none' }}>
                    {t('footer.productAiops')}
                  </a>
                  <a href="https://rebaz.ai/dispatch/" style={{ color: 'white', textDecoration: 'none' }}>
                    {t('footer.productDispatch')}
                  </a>
                  <a href="https://rebaz.ai/roblox/" style={{ color: 'white', textDecoration: 'none' }}>
                    {t('footer.productRoblox')}
                  </a>
                </>
              )}
            </Box>
          </Grid>

          {/* About Column */}
          <Grid item xs={6} md={4}>
            <Typography variant="h6" fontWeight="bold" gutterBottom>
              {t('footer.about')}
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <a href="/columns" style={{ color: 'white', textDecoration: 'none' }}>
                {t('footer.blog')}
              </a>
              <Link to="/privacy" style={{ color: 'white', textDecoration: 'none' }}>
                {t('footer.privacyPolicy')}
              </Link>
              <Link to="/terms" style={{ color: 'white', textDecoration: 'none' }}>
                {t('footer.termsOfService')}
              </Link>
              <Link to="/data-deletion" style={{ color: 'white', textDecoration: 'none' }}>
                {t('footer.dataDeletion')}
              </Link>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Typography variant="body2" align="center" sx={{ mt: 4 }}>
          {t('footer.copyright', { year: currentYear })}
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
